export async function racquetResponse(response) {
  const payload = await response.json().catch(() => null)
  if (!response.ok)
    throw Object.assign(new Error(payload?.error || 'request_failed'), {
      code: payload?.error,
      status: response.status
    })
  return payload.data
}
export const racquetPath = (club, suffix) =>
  `/api/members-portal/${encodeURIComponent(club)}/lets-play/racquet${suffix}`
export function downloadRacquetPending(queue) {
  const url = URL.createObjectURL(
      new Blob([queue.exportPending()], { type: 'application/json' })
    ),
    a = document.createElement('a')
  a.href = url
  a.download = 'privana-pending-match.json'
  a.click()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}

const errorCodes = new Set([
  'completed_segment_has_points', 'point_combination_invalid', 'point_mode_changed', 'draft_revision_changed', 'draft_consent_required', 'draft_action_required', 'draft_unreadable',
  'unfinished_segment_must_be_last',
  'mark_segment_completed',
  'invalid_segment_score',
  'invalid_point_score',
  'invalid_game_score',
  'invalid_correction',
  'service_information_required',
  'invalid_service_box',
  'invalid_service_order',
  'server_number_required',
  'court_positions_required',
  'invalid_court_positions',
  'terminal_score_requires_segment',
  'summary_would_rewrite_games',
  'dependent_history_requires_resolution',
  'queue_capacity_reached',
  'court_not_available_for_sport',
  'format_not_supported_by_court',
  'duplicate_participant',
  'reason_required'
])
export const racquetErrorKey = (code) =>
  errorCodes.has(code) ? `error_${code}` : 'error'
